import { GECKO_CONSTS } from '@geckolabs/gecko-react-ui';

let ATTENDANCE = {};

ATTENDANCE.STATUS_REGISTERED 		= 10;
ATTENDANCE.STATUS_INVITED    		= 20;
ATTENDANCE.STATUS_ATTENDED   		= 30;
ATTENDANCE.STATUS_ENGAGED    		= 40;
ATTENDANCE.STATUS_WAITLISTED 		= 50;
ATTENDANCE.STATUS_CHECKIN 	 		= 60;
ATTENDANCE.STATUS_CHECKINAFTER 		= 70;
ATTENDANCE.STATUS_REMOVED    		= 80;
ATTENDANCE.STATUS_CANCELLED  		= 90;
ATTENDANCE.STATUS_DID_NOT_ATTEND	= 100;

ATTENDANCE.ATTENDING_YES      = 'yes';
ATTENDANCE.ATTENDING_NO       = 'no';
ATTENDANCE.ATTENDING_WAITLIST = 'waitlist';

ATTENDANCE.TITLES = {
	[ATTENDANCE.STATUS_REGISTERED] 	 	: 'Registered',
	[ATTENDANCE.STATUS_INVITED]    	 	: 'Invited',
	[ATTENDANCE.STATUS_ATTENDED]   	 	: 'Attended',
	[ATTENDANCE.STATUS_ENGAGED]    	 	: 'Engaged',
	[ATTENDANCE.STATUS_WAITLISTED] 	 	: 'Waitlisted',
	[ATTENDANCE.STATUS_CHECKIN] 	 	: 'Check in',
	[ATTENDANCE.STATUS_CHECKINAFTER] 	: 'Check in from ',
	[ATTENDANCE.STATUS_REMOVED]    	 	: 'Removed',
	[ATTENDANCE.STATUS_CANCELLED]  	 	: 'Cancelled',
	[ATTENDANCE.STATUS_DID_NOT_ATTEND]  : 'Did Not Attend'
};

ATTENDANCE.ICONS = {
	[ATTENDANCE.STATUS_REGISTERED] 	 	: 'fa-user-check',
	[ATTENDANCE.STATUS_INVITED]    	 	: 'fa-user-check',
	[ATTENDANCE.STATUS_ATTENDED]   	 	: 'fa-user-check',
	[ATTENDANCE.STATUS_ENGAGED]    	 	: 'fa-user-check',
	[ATTENDANCE.STATUS_WAITLISTED] 	 	: 'fa-clock far',
	[ATTENDANCE.STATUS_CHECKIN] 	 	: 'fa-user-check',
	[ATTENDANCE.STATUS_CHECKINAFTER] 	: 'fa-user-check',
	[ATTENDANCE.STATUS_REMOVED]    	 	: 'ban',
	[ATTENDANCE.STATUS_CANCELLED]  	 	: 'ban',
	[ATTENDANCE.STATUS_DID_NOT_ATTEND]  : 'ban'
};

ATTENDANCE.TITLE_TYPES = {
	[ATTENDANCE.STATUS_REGISTERED] 	 	: GECKO_CONSTS.LABEL_TYPE_DEFAULT,
	[ATTENDANCE.STATUS_INVITED]   	 	: GECKO_CONSTS.LABEL_TYPE_WARNING,
	[ATTENDANCE.STATUS_ATTENDED]  	 	: GECKO_CONSTS.LABEL_TYPE_DEFAULT,
	[ATTENDANCE.STATUS_ENGAGED]   	 	: GECKO_CONSTS.LABEL_TYPE_DEFAULT,
	[ATTENDANCE.STATUS_WAITLISTED]	 	: GECKO_CONSTS.LABEL_TYPE_WARNING,
	[ATTENDANCE.STATUS_CHECKIN] 	 	: GECKO_CONSTS.LABEL_TYPE_PRIMARY,
	[ATTENDANCE.STATUS_CHECKINAFTER] 	: GECKO_CONSTS.LABEL_TYPE_DEFAULT,
	[ATTENDANCE.STATUS_REMOVED]    	 	: GECKO_CONSTS.LABEL_TYPE_DANGER,
	[ATTENDANCE.STATUS_CANCELLED]  	 	: GECKO_CONSTS.LABEL_TYPE_DANGER,
	[ATTENDANCE.STATUS_DID_NOT_ATTEND]  : GECKO_CONSTS.LABEL_TYPE_DEFAULT
};

export default ATTENDANCE;